import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import Hero_Section from '../components/Hero_Section'
// import Research_Section from '../components/Research_Section'
import News_Section from '../components/News_Section'
// import Publication_Section from '../components/Publication_Section'
import Affiliations_Section from '../components/Affiliations_Section'
// import About_Section from '../components/About_Section'
import Contact_Section from '../components/Contact_Section'

var marked = require('marked');

class IndexPage extends React.Component {
  render() {
    const blobs = this.props.data.allContentfulBlob.edges;
    let reduced = blobs.reduce((prev, curr) => {
      let title = curr.node.title;
      let body = curr.node.body.body;
      return {
          ...prev,
          [title]: {
            title: title,
            body: body
          }
        };
      }, []);
      // const publications = this.props.data.allContentfulPublication.edges;
      const news = this.props.data.allContentfulNews.edges;

    return (
      <div style={{ minHeight: '100vh'}}>
        <Hero_Section text={reduced["hero"].body}/>
        {/* <Research_Section text={reduced["Research"].body}/> */}
        <News_Section news={news} />
        {/* <Publication_Section publications={publications}/> */}
        {/* <About_Section text={reduced["About"].body}/> */}
        <Contact_Section text={reduced["Contact"].body}/>
        <Affiliations_Section />
      </div>
    )
  }
}

export default IndexPage

export const query = graphql`
  query IndexQuery {
    allContentfulBlob {
      edges {
        node {
          title,
          body {
            body
          }
        }
      }
    }
    # allContentfulPublication (
    #   sort: { fields: [year], order: DESC },
    #   limit: 2
    #   ) {
    #   edges {
    #     node {
    #       title
    #       authors
    #       year
    #       journal
    #       doiNumber
    #       abstractUrl
    #     }
    #   }
    # }
    allContentfulCourse {
      edges {
        node {
          title
          institution
          semester
          courseType
        }
      }
    }
    allContentfulNews (
      sort: { fields: [date], order: DESC },
      limit: 3
    ) {
      edges {
        node {
          title
          date
          type
          description {
            description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js